const FlightPlanningStyles = (theme) => { 
  return {
    rooted: {
      display: "flex",
    },
    formControl: {
      margin: theme.spacing(3),
    },
    root: {
      flexGrow: 1,
      height: 250,
    },
    container: {
      flexGrow: 1,
      position: "relative",
    },
    paper: {
      position: "absolute",
      zIndex: 1,
      marginTop: theme.spacing(1),
      left: 0,
      right: 0,
    },
    chip: {
      margin: theme.spacing(0.5, 0.25),
    },
    inputRoot: {
      flexWrap: "wrap",
    },
    inputInput: {
      width: "auto",
      flexGrow: 1,
    },
    divider: {
      height: theme.spacing(2),
    },
    progress: {
      margin: theme.spacing(2),
    },

    priceTooltip: {
      width: 400,
      minWidth: 400,
      maxWidth: 400,
    },
    scheduledTripLegEditor: {
      "& .MuiTableHead-root": {
          backgroundColor: theme.palette.childTableHeader.backgroundColor,
          display: "block",
          tableLayout: "fixed",
          paddingRight: 20,
      },
      "& .MuiTableSortLabel-root": {
          color: theme.palette.secondary.main,
      }
    },
    TripLegEditor: {
      "& .MuiTableHead-root": {
          backgroundColor: theme.palette.childTableHeader.backgroundColor,
          display: "block",
          tableLayout: "fixed",
          paddingRight: 20,
      },
      "& .MuiTableSortLabel-root": {
          color: theme.palette.secondary.main,
      }
    }
  }
}

export default FlightPlanningStyles;
